import React from 'react';

interface IProp {
    texts: any[]
}

class SampleMultiTextComponent extends React.Component<IProp, {}> {

    constructor(props){
        super(props);
    }

    renderText(text: string, i: number) {
        return (
            <p key={i} className="goepik-component-no-margin-bottom">{text}</p>
        )
    }

    render(): JSX.Element {
        return (
            <div>
                {
                    this.props.texts.map((text, i) => {
                        return this.renderText(text, i)
                    })
                }
            </div>
        );
    }
};

export default SampleMultiTextComponent;
